// export const environment = {
//   production: true,
//   adminApiUrl: 'https://api.mylead.biz/api/admin_panel',
//   apiUrl: 'https://api.mylead.biz/api/publisher_panel',
//   socketioURL: '//node.mylead.biz',
//   client_id: '3',
//   client_secret: '8UrzuSrGiwm5LNBmjzmEIQUqniFKz43I8pYa2W0R', // .biz
//   recaptcha: {
//     siteKey: '6LerKVoqAAAAAOyOwDAaVp8OpqUXwvZWw3Bj15_e'
//   },
//   loginRecaptcha: {
//     siteKey: '6LdkV1wqAAAAADtUwiwXyW_Yg7lcAwQFsO4-bQLD'
//   },
//   discordUrl: 'https://discord.gg/6twGtVYdKS',
//   domain: 'mylead.biz',
//   testRecaptcha: false,
//   build: 1.42
// };

export const environment = {
  production: true,
  adminApiUrl: 'https://api.mylead.global/api/admin_panel',
  apiUrl: 'https://api.mylead.global/api/publisher_panel',
  socketioURL: '//node.mylead.global',
  client_id: '3',
  client_secret: 'pAz0c5H740cBxZmDEYdhW8FZ5EYSZOJOamlnA4pF',
  recaptcha: {
    siteKey: '6LerKVoqAAAAAOyOwDAaVp8OpqUXwvZWw3Bj15_e'
  },
  loginRecaptcha: {
    siteKey: '6LdkV1wqAAAAADtUwiwXyW_Yg7lcAwQFsO4-bQLD'
  },
  discordUrl: 'https://discord.gg/zdnEAAN9fw',
  domain: 'pub.mylead.global',
  testRecaptcha: false,
  build: 1.42
};
